"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_ctv_framework_main_1 = require("@sky-uk-ott/client-lib-js-ctv-framework-main");
exports.DeviceRecognition = client_lib_js_ctv_framework_main_1.DeviceRecognition;
var common_player_component_1 = require("./common-player-component");
exports.CommonPlayerComponent = common_player_component_1.CommonPlayerComponent;
exports.default = client_lib_js_ctv_framework_main_1.PlayerFramework;
